import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AnalyticsProvider } from './lib/analytics';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const analyticsConfig = {
  apiKey: import.meta.env.VITE_POSTHOG_KEY ?? '',
  apiHost: import.meta.env.VITE_POSTHOG_HOST,
  disabled: import.meta.env.VITE_ANALYTICS_ENABLED !== 'true',
  sessionRecording: true,
  provider: 'posthog' as const,
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <AnalyticsProvider config={analyticsConfig}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </AnalyticsProvider>
  </React.StrictMode>
);
